module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/9-bg-1764a918dd05c60b17b2cd8d68b7641e.png";